import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import jwt_decode from "jwt-decode";
// import * as Excel from "exceljs";
// import { Workbook } from 'exceljs';
import { BehaviorSubject, Observable } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { CookieService } from "ngx-cookie-service";
import { User } from "src/app/models/user";

@Injectable({
  providedIn: "root",
})
export class TeamsService {
  user?: User;

  private userRoleSubject = new BehaviorSubject<string | null>(null);
  userRole$ = this.userRoleSubject.asObservable();

  constructor(private http: HttpClient, private cookieService: CookieService) {}

  getUserRole(): string | null {
    return this.userRoleSubject.value;
  }

  isAdmin(): boolean {
    return this.userRoleSubject.value === "ADMIN";
  }

  isOperationAdmin(): boolean {
    return this.userRoleSubject.value === "OPERATION_ADMIN";
  }

  isAdminOrOperationAdmin(): boolean {
    return this.isAdmin() || this.isOperationAdmin();
  }

  getUser(): User | undefined {
    return this.user;
  }

  setUser(user?: User) {
    this.user = user;
  }

  getIdUser() {
    var user: any = this.getUser();

    if (user) {
      return user["idUser"];
    } else {
      return null;
    }
  }

  getTypeUser() {
    var user: any = this.getUser();

    if (user) {
      return user["type"];
    } else {
      return null;
    }
  }
  isResponsible() {
    return this.getTypeUser() === "ResponsibleDriver";
  }

  isConnected() {
    const jwtToken = this.cookieService.get("JWT_TAXI");
    // console.log("token : " + jwtToken);
    return !!jwtToken;
  }

  login(creds: any) {
    return new Promise((solve) => {
      this.http.post(environment.apiUsersAuth, creds).subscribe((res: any) => {
        // console.log(res);
        // console.log('Login response:', res); // Debug
        if (res) {
          if (res?.response && res?.data) {
            solve(true);
          } else {
            solve(false);
          }
        }
      });
    });
  }

  async fetchUser() {
    try {
      const response: any = await this.http
        .get(environment.apiUserProfile)
        .toPromise();

      this.userRoleSubject.next(response?.data?.scope);
      return response?.data;
    } catch (err) {
      throw err;
    }
  }

  async saveToken(token: any) {
    try {
      const response: any = await this.http
        .put(environment.apiUserSaveToken, {
          fcmtoken: token,
        })
        .toPromise();
      // console.log(response?.data)
      this.userRoleSubject.next(response?.data?.scope);
      return response?.data;
    } catch (err) {
      // Rejeter l'erreur pour propagation
      throw err;
    }
  }

  logout() {
    return new Promise((solve) => {
      this.http.get(environment.apiUsersLogout).subscribe((res: any) => {
        // console.log(res);
        if (res) {
          if (res.response) {
            solve(true);
          } else {
            solve(false);
          }
        }
      });
    });
  }

  fetchNotification(notificationId: any) {
    return new Promise((solve) => {
      this.http
        .get(environment.apiUserNotification + "/" + notificationId)
        .subscribe((res: any) => {
          // console.log(res);
          if (res) solve(res);
          else solve(null);
        });
    });
  }

  fetchNotifications(type: any, page: number) {
    let params = new HttpParams().set("page", page);
    return new Promise((solve) => {
      this.http
        .get(environment.apiUserNotifications + "/" + type, { params })
        .subscribe((res: any) => {
          // console.log(res);
          if (res) {
            if (res.response) {
              solve(res?.data);
            } else {
              solve([]);
            }
          }
        });
    });
  }

  clearAllNotifications(type: any) {
    return new Promise((solve) => {
      this.http
        .put(environment.apiClearAllNotifications + "/" + type, {})
        .subscribe((res: any) => {
          // console.log(res);
          if (res) {
            solve(res);
          } else {
            solve(null);
          }
        });
    });
  }

  openNotification(notificationId: any, type: any) {
    return new Promise((solve) => {
      this.http
        .put(
          environment.apiUserNotification + "/" + notificationId + "/" + type,
          {},
        )
        .subscribe((res: any) => {
          // console.log(res);
          if (res) {
            if (res.response) {
              solve(res?.data);
            } else {
              solve(null);
            }
          }
        });
    });
  }

  public saveDataInCSV(data: Array<any>): string {
    // console.log(data)
    if (data.length == 0) {
      return "";
    }

    let propertyNames = [
      "CONTACT_ID",
      "EMAIL",
      "FIRSTNAME",
      "LASTNAME",
      "SMS",
      "LANDLINE_NUMBER",
      "WHATSAPP",
    ]; //.keys(data[0]);
    let rowWithPropertyNames = propertyNames.join(",") + "\n";

    let csvContent = rowWithPropertyNames;

    let rows: string[] = [];

    data.forEach((item) => {
      let values: string[] = [
        item?.id,
        item?.emailUser,
        item?.prenomUser,
        item?.nomUser,
      ];
      rows.push(values.join(","));
    });
    csvContent += rows.join("\n");

    return csvContent;
  }
}
